var url = {
    isTest: process.env.NODE_ENV === 'development',
    getHost: function () {
        if (this.isTest)
            return 'localhost:55161';
            // return 'localhost:56822';
        // return 'xiaohuatest.qianlekh.com';
        return 'crm.muzixiaohua.com';
    },
    getDomain: function () {
        if (this.isTest)
            return `http://${this.getHost()}`;
        return `https://${this.getHost()}`;
    },
    getController: function (str) {
        return `${this.getDomain()}/${str}`;
    },
    //UE服务端接口
    getUE: function () {
        return this.getController('api/ueditor');
    },
    //UE配置地址
    getUEConfig: function () {
        if (this.isTest)
            return '/UEditor/';
        return '/vue/UEditor/';
    },
    //统一上传地址
    getUpload: function () {
        if (this.isTest)
            return "ws://" + this.getHost() + "/upload/common";
        return "wss://" + this.getHost() + "/upload/common";
    },
    getCompany: function (str) {
        var controller = this.getController('company');
        if (str)
            controller += '/' + str;
        return controller;
    },
    getAccount(str) {
        var controller = this.getController('api/account');
        if (str)
            controller += '/' + str;
        return controller;
    },
    getCategory(str) {
        var controller = this.getController('categoryinfo');
        if (str)
            controller += '/' + str;
        return controller;
    },
    getSubject(str) {
        var controller = this.getController('subjectinfo');
        if (str)
            controller += '/' + str;
        return controller;
    },
    getCards(str) {
        var controller = this.getController('cardsinfo');
        if (str)
            controller += '/' + str;
        return controller;
    },
    getSys(str) {
        var controller = this.getController('api/sys');
        if (str)
            controller += '/' + str;
        return controller;
    },
    //学生跟进详情
    getStu(str) {
        var controller = this.getController('api/stu');
        if (str)
            controller += '/' + str;
        return controller;
    },
    //学生跟进列表
    getCommon(str) {
        var controller = this.getController('api/common');
        if (str)
            controller += '/' + str;
        return controller;
    },
    //通知管理
    getNotice(str) {
        var controller = this.getController('api/notice');
        if (str)
            controller += '/' + str;
        return controller;
    },
    //汇总接口
    getCollect(str) {
        var controller = this.getController('api/collect');
        if (str)
            controller += '/' + str;
        return controller;
    },
    //日语资源
    getJap(str) {
        var controller = this.getController('api/jap');
        if (str)
            controller += '/' + str;
        return controller;
    },
    //日语资源汇总
    getJapCollect(str) {
        var controller = this.getController('api/japcollect');
        if (str)
            controller += '/' + str;
        return controller;
    },
    //鸣野资源
    getMingye(str) {
        var controller = this.getController('api/mingye');
        if (str)
            controller += '/' + str;
        return controller;
    },
    //学校管理
    getSchool(str) {
        var controller = this.getController('api/school');
        if (str)
            controller += '/' + str;
        return controller;
    },
    getStudent_Exprience(str) {
        var controller = this.getController('api/student_exprience');
        if (str)
            controller += '/' + str;
        return controller;
    },
     //淘汰原因
     getER(str) {
        var controller = this.getController('api/eliminate_Reason');
        if (str)
            controller += '/' + str;
        return controller;
    },
    /**********通用数据定义************ */
    //获取来源定义
    getOriginData() {
        //获取来源定义
        var data = [
            { id: "知乎", name: "知乎" },
            { id: "微博", name: "微博" },
            { id: "官网评估咨询", name: "官网评估咨询" },
            { id: "公众号", name: "公众号" },
            { id: "B站", name: "B站" },
            { id: "抖音", name: "抖音", children: [{ id: "直播", name: "直播" }, { id: "短视频", name: "短视频" }] },
            { id: "网络搜索", name: "网络搜索" },
            { id: "学生推荐", name: "学生推荐" },
            { id: "合作方推荐", name: "合作方推荐" },
            { id: "小红书", name: "小红书" },
            { id: "百度贴吧", name: "百度贴吧" },
            { id: "大众点评", name: "大众点评" },
            { id: "教育宝", name: "教育宝" },
            { id: "油管", name: "油管" },
            { id: "线下市场", name: "线下市场", isRemark: true },
            { id: "豆瓣", name: "豆瓣" },
            { id: "留学组推荐", name: "留学组推荐" },
            { id: "日语组推荐", name: "日语组推荐" },
            { id: "百度竞价", name: "百度竞价" },
            { id: "知了好学", name: "知了好学" },
            { id: "青学纪", name: "青学纪" },
            { id: "小程序", name: "小程序" },
            { id: "未知", name: "未知" },
            { id: "其他", name: "其他", isRemark: true },
        ];
        return data;
    },
    //获取留学时间定义
    getAbroadYear() {
        var now = new Date();
        var year = now.getFullYear();
        var data = [
            // (year - 5) + "年",
            // (year - 4) + "年",
            // (year - 3) + "年",
            // (year - 2) + "年",
            // (year - 1) + "年",
            year + "年",
            (year + 1) + "年",
            (year + 2) + "年",
            (year + 3) + "年",
            (year + 4) + "年",
            "5年后",
            "未定"
        ];
        return data;
    },
    //获取状态列表
    getStateData() {
        return [
            { id: undefined, name: "请选择" },
            { id: "s", name: "s" },
            { id: "a", name: "a" },
            { id: "b", name: "b" },
            { id: "c", name: "c" },
            { id: "d", name: "d" },
            { id: "e", name: "e" },
            { id: "f", name: "f" },
            { id: "g", name: "g" }
        ];
    },
    //获取学历数据
    getEduBack() {
        return [
            { id: "小学", name: "小学" },
            { id: "初中", name: "初中" },
            { id: "中专/高职", name: "中专/高职" },
            { id: "高中", name: "高中" },
            { id: "3+2", name: "3+2" },
            { id: "大专", name: "大专" },
            { id: "本科", name: "本科" },
            { id: "硕士", name: "硕士" },
            { id: "其他", name: "其他" }
        ];
    },
    /** 日语等级（日语资源、鸣野用）：零基础/初级/中级/高级 */
    getJapLevelList() {
        return [
            { id: "零基础", name: "零基础" },
            { id: "初级", name: "初级" },
            { id: "中级", name: "中级" },
            { id: "高级", name: "高级" },
        ];
    },
    /** 日语等级（留学/学生用）：N1~N5、无证书、零基础 */
    getJapLevelListForStu() {
        return [
            { id: "n1", name: "n1" },
            { id: "n2", name: "n2" },
            { id: "n3", name: "n3" },
            { id: "n4", name: "n4" },
            { id: "n5", name: "n5" },
            { id: "无证书", name: "无证书" },
            { id: "零基础", name: "零基础" },
        ];
    },
    /** 学生类型（学生/家长） */
    getStudentTypeList() {
        return [
            { id: "学生", name: "学生" },
            { id: "家长", name: "家长" },
        ];
    },
    /** 年龄阶段（留学板块筛选用） */
    getAgeRangeList() {
        return [
            { id: "20以内", name: "20以内" },
            { id: "20-25", name: "20-25" },
            { id: "25-30", name: "25-30" },
            { id: "30-35", name: "30-35" },
            { id: "35-40", name: "35-40" },
            { id: "40以上", name: "40以上" },
        ];
    },
    /** 赴日目的/留学目的（留学板块筛选用） */
    getStudentPurposeList() {
        return [
            { id: "升学", name: "升学" },
            { id: "就职", name: "就职" },
            { id: "专门学校", name: "专门学校" },
            { id: "体验", name: "体验" },
            { id: "未定", name: "未定" },
        ];
    },
    /** 学习目的（日语板块筛选用） */
    getPurposeList() {
        return [
            { id: "兴趣", name: "兴趣" },
            { id: "留学", name: "留学" },
            { id: "就职", name: "就职" },
            { id: "高考日语", name: "高考日语" },
            { id: "考研辅导", name: "考研辅导" },
            { id: "赴日工作", name: "赴日工作" },
            { id: "在日升学", name: "在日升学" },
            { id: "工作", name: "工作" },
            { id: "未定", name: "未定" },
        ];
    },
    /** 意向上课形式（日语板块筛选用） */
    getIntendedFormList() {
        return [
            { id: "网课", name: "网课" },
            { id: "线下课", name: "线下课" },
            { id: "录播课", name: "录播课" },
            { id: "其他", name: "其他" },
        ];
    },
}
export default url;